import React from "react";
import { component_tool, utils_tool } from '@/tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;


//配置项
let componentName = 'reportConfig'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "报表名称",
    name: "name",
    dataIndex: "name",
    tableItem: {}
  },
  {
    title: "报表名称",
    name: "nameSearch",
    dataIndex: "nameSearch",
    searchItem: {},
  },
  {
    title: "创建人",
    name: "creator",
    dataIndex: "creator",
    tableItem: {}
  },
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  },
  {
    title: "备注",
    name: "remark",
    dataIndex: "remark",
    tableItem: {}
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      btnAccessCheck:false,
      searchBarProps: {
        collapse:false,
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/dataReport/reportConfigList/reportConfigAdd"
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      rowOperateSort: ['update','evaluationManagement'],
      rowOperateView: [
        {
          key: 'look',//课程查看
          custom: true,
          params: { children: '查看'},
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/program/programList/programDetailShow'
            }
          }
        },
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/dataReport/reportConfigList/reportConfigUpd"
            }
          }
        },
        {
          key: "evaluationManagement",
          custom: true,
          params: { children: "查看报表"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/dataReport/reportConfigList/reportConfigDetailList"
            }
          }
        },
      ],
      commonOperate: {
      },
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10,isPower:true }
    }
  }
  ,
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {isPower:true}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
